import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaArrowRight, FaCheck, FaWhatsapp } from "react-icons/fa";
import pages from "../../data/pages.json";
import "./Hero.css";

const WHATSAPP_URL = "https://wa.me/94766251456";

const trust = ["Fixed-price quotes", "Weekly demos", "You own the code"];

// Values must match the service options in Contact.js so the form prefills.
const needs = [
  { label: "Website", value: "Website with SEO" },
  { label: "Online store", value: "Online store" },
  { label: "Mobile app", value: "Mobile app" },
  { label: "Odoo ERP", value: "Odoo ERP" },
  { label: "POS / inventory", value: "POS or inventory" },
  { label: "Something else", value: "Other" },
];

const steps = [
  "Tell us what you need",
  "Get a fixed price within one working day",
  "See progress in a demo every week",
];

const Hero = () => {
  const [need, setNeed] = useState("");

  const startQuote = () => {
    window.dispatchEvent(
      new CustomEvent("lk:prefill", { detail: need ? { service: need } : {} })
    );
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="lk-hero">
      <div className="lk-container lk-hero-inner">
        <motion.div
          className="lk-hero-copy"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="lk-eyebrow">Software company · Sri Lanka</div>
          <h1 className="lk-hero-title">{pages.home.h1}</h1>
          <p className="lk-hero-text">{pages.home.intro}</p>
          <div className="lk-hero-actions">
            <a href="#contact" className="lk-btn lk-btn-primary">
              Start a project
              <FaArrowRight aria-hidden="true" />
            </a>
            <a href="#work" className="lk-btn lk-btn-ghost">
              See our work
            </a>
          </div>
          <ul className="lk-hero-trust">
            {trust.map((item) => (
              <li key={item}>
                <FaCheck aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
          <p className="lk-hero-proof">
            Recently launched:{" "}
            <a href="#work">Karakaara.lk</a>, a website, Android app and admin
            dashboard.
          </p>
        </motion.div>

        <motion.div
          className="lk-hero-quote"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h2>What do you need?</h2>
          <div className="lk-hero-needs" role="group" aria-label="What do you need?">
            {needs.map(({ label, value }) => (
              <button
                key={value}
                type="button"
                className={need === value ? "is-active" : ""}
                aria-pressed={need === value}
                onClick={() => setNeed(need === value ? "" : value)}
              >
                {label}
              </button>
            ))}
          </div>

          <ol className="lk-hero-steps">
            {steps.map((step, i) => (
              <li key={step}>
                <span>{i + 1}</span>
                {step}
              </li>
            ))}
          </ol>

          <button type="button" className="lk-btn lk-btn-primary lk-hero-quote-btn" onClick={startQuote}>
            Get a free quote
            <FaArrowRight aria-hidden="true" />
          </button>
          <a className="lk-hero-wa" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp aria-hidden="true" />
            Prefer to talk? Message us on WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
